import { useEffect, useState } from "react";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";
import { api, errMsg } from "@/lib/api";

const Toggle = ({ on, onClick, testId, label }) => (
  <button onClick={onClick} aria-pressed={on} data-testid={testId} className="flex items-center gap-2 text-xs text-slate-300">
    <span className={`w-8 h-4 rounded-full relative ${on ? "bg-emerald-500" : "bg-slate-600"}`}>
      <span className={`absolute left-0 top-0.5 w-3 h-3 rounded-full bg-white transition-transform ${on ? "translate-x-4" : "translate-x-0.5"}`} />
    </span>{label}
  </button>
);

export function WhatsAppAlerts() {
  const [a, setA] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/alerts").then((r) => setA(r.data)).catch(() => {}); }, []);
  if (!a) return null;
  const save = async (next) => {
    try { setA((await api.put("/alerts", { on: next.on, phone: next.phone, engine: next.engine })).data); toast.success("WhatsApp alerts saved"); } catch (e) { toast.error(errMsg(e)); }
  };
  const test = async () => {
    setBusy(true);
    try { await api.post("/alerts/test"); toast.success("Test sent — check WhatsApp"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
    api.get("/alerts").then((r) => setA(r.data));
  };
  return (
    <div className="panel p-4 space-y-3" data-testid="whatsapp-alerts">
      <div className="flex items-center gap-2"><MessageCircle size={15} className="text-emerald-300" /><span className="text-sm font-semibold text-slate-100">WhatsApp alerts</span>
        {!a.key_set && <span className="text-[11px] text-amber-300 ml-2" data-testid="whatsapp-key-missing">key not set yet</span>}</div>
      <p className="text-[11px] text-slate-400">Zerodha login reminder at 08:50 and 09:05 on weekdays (only if you're not logged in), plus engine start / restart / resume messages.
        One-time setup: save the CallMeBot number shown on callmebot.com in your phone, send it “I allow callmebot to send me messages” on WhatsApp, and you'll receive your key.</p>
      <div className="flex flex-wrap items-center gap-3">
        <input value={a.phone} onChange={(e) => setA({ ...a, phone: e.target.value })} onBlur={() => save(a)} placeholder="+91 98xxxxxx10" data-testid="whatsapp-phone-input"
          className="h-9 w-48 rounded-md bg-[#0B111D] border border-[#1E293B] px-2 text-xs num text-slate-200" />
        <Toggle on={a.on} onClick={() => save({ ...a, on: !a.on })} testId="whatsapp-on-toggle" label={a.on ? "Alerts ON" : "Alerts OFF"} />
        <Toggle on={a.engine} onClick={() => save({ ...a, engine: !a.engine })} testId="whatsapp-engine-toggle" label="Engine events" />
        <button onClick={test} disabled={busy} data-testid="whatsapp-test-btn" className="h-9 px-3 rounded-md border border-emerald-500/50 text-emerald-300 text-xs hover:bg-emerald-500/10 disabled:opacity-50">
          {busy ? "Sending…" : "Send test message"}
        </button>
      </div>
      {!!a.recent?.length && (
        <div className="space-y-0.5" data-testid="whatsapp-recent">
          {a.recent.map((m, i) => (
            <div key={i} className="text-[11px] num flex gap-2"><span className="text-slate-500">{m.at?.slice(5, 16).replace("T", " ")}</span>
              <span className={m.ok ? "text-emerald-300" : "text-red-300"}>{m.ok ? "sent" : "failed"}</span>
              <span className="text-slate-400 truncate">{m.ok ? m.text : m.error}</span></div>
          ))}
        </div>
      )}
    </div>
  );
}
